module.exports = fox._r("var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/phones.png", __webpack_public_path__ + "_/_/_/common/components/mobile/images/phones.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/images/phones.png
// module id = 598
// module chunks = 2